var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{staticClass:"btn-properties",class:_vm.internalValue ? _vm.activeClass : '',attrs:{"variant":"radio","size":_vm.size},on:{"click":_vm.toggleValue}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm._f("tr")(_vm.label)))]}),(_vm.internalValue)?_c('i',{staticClass:"fas fa-check floating-check-mark ml-1"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }